import { campaignAPI } from "@api";
import { ArrowLeftColor } from "@components";
import { IMemberTier } from "@interfaces";
import { selectMerchant } from "@redux";
import { RenderMeta } from "@utils";
import { Card, Skeleton } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import styled from "styled-components";
import { RankIcon } from "../icon/Campaign/RankIcon";

interface IProps {
    socials: JSX.Element[];
    avatar: string;
    fullName: string;
    memberTier: IMemberTier | undefined;
    isConfirm?: boolean;
}

export const ComponentMyStateLeaderBoardPage = (props: IProps) => {
    //page props
    const { socials } = props;
    const { t } = useTranslation();
    const { id } = useParams<{ id: string }>();
    const merchant = useSelector(selectMerchant);
    const history = useHistory();
    const { themes } = useSelector(selectMerchant);
    const [myData, setMyData] = useState<any>();
    const [userList, setUserList] = useState<any>([]);
    const [campaign, setCampaign] = useState<any>();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const getCampaign = async () => {
        setIsLoading(true);
        try {
            const getMe = await campaignAPI.getMyCampaignData(id);
            const getUser = await campaignAPI.getUserCampaignData(id, "");
            const get = await campaignAPI.getCampaign(id);
            console.log(
                "get",
                get.data?.mechanics?.filter((type: any) => type.type === "LEADERBOARD")[0]
            );
            if (get.data) {
                setCampaign(
                    get.data?.mechanics?.filter((type: any) => type.type === "LEADERBOARD")[0]
                        ? get.data?.mechanics?.filter((type: any) => type.type === "LEADERBOARD")[0]
                        : []
                );
            }
            if (getMe.data) {
                setMyData(getMe.data);
            }
            if (getUser.data) {
                setUserList(getUser.data);
            }
            setIsLoading(false);
        } catch (err: any) {
            console.log(err);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        getCampaign();
    }, []);

    const cardRankLoading = () => {
        return (
            <StyledLoadingRankCard>
                <Skeleton
                    avatar
                    loading={isLoading}
                    active
                    title={false}
                    paragraph={{ rows: 2 }}
                ></Skeleton>
            </StyledLoadingRankCard>
        );
    };

    const getMyData = userList.find((user: any) => user.userId === myData.userId);

    return (
        <>
            <RenderMeta title={t("meta.stateleaderboard_page")} />
            <StlyedSocialMedia themeColor={themes?.themeColor!}>
                <div className="back-arrow">
                    <ArrowLeftColor color={themes?.themeColor} onClick={() => history.goBack()} />
                </div>
                <div className="title-page">{t("page.campaign.leaderboard")}</div>
                <div className="img-banner">
                    <span>
                        <img
                            src={campaign?.coverBackground ? campaign?.coverBackground : ""}
                            alt=""
                        />
                    </span>
                </div>
                <div className="layout-content">
                    <div className="main-content">
                        <div className="box-content">
                            {/* {userList?.filter((item: any) => item.ranking > 0).length > 1 ? ( */}
                            {userList?.filter((item: any) => item.ranking >= 0).length > 0 ? (
                                <div className="wrapper-state-leaderboard">
                                    {isLoading ? cardRankLoading() : <></>}
                                    {userList?.map((item: any, index: number) => {
                                        return isLoading ? (
                                            cardRankLoading()
                                        ) : (
                                            <div className="ranking-state-leaderboard" key={index}>
                                                <div className="ranking">
                                                    <div className={"relative"}>
                                                        {item.ranking <=
                                                            campaign?.numberOfRanking && (
                                                            <img
                                                                src={
                                                                    campaign?.ranking[item.ranking]
                                                                        ?.badgeIcon
                                                                }
                                                            />
                                                        )}
                                                        <p
                                                            style={{
                                                                color:
                                                                    item.ranking + 1 <=
                                                                    campaign?.numberOfRanking
                                                                        ? "white"
                                                                        : "black",
                                                                position: "absolute",
                                                                top: "50%",
                                                                left: "50%",
                                                                transform: "translate(-50%, -50%)",
                                                                fontWeight: 700,
                                                            }}
                                                        >
                                                            {item.ranking + 1}
                                                        </p>

                                                        <span>
                                                            {item.ranking >= 0 &&
                                                            item.ranking + 1 <=
                                                                campaign?.numberOfRanking ? (
                                                                <RankIcon
                                                                    color={
                                                                        campaign?.ranking[
                                                                            item.ranking
                                                                        ]?.color
                                                                    }
                                                                />
                                                            ) : (
                                                                ""
                                                            )}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="img">
                                                    <img
                                                        src={
                                                            item?.imageUrl
                                                                ? item?.imageUrl
                                                                : "../../images/img-profile-default-01.png"
                                                        }
                                                        alt=""
                                                    />
                                                </div>
                                                <div className="name">{item.firstName}</div>
                                                <div className="tel">{item.phoneNumber}</div>
                                                <div className="point">{item.totalPoint}</div>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <p
                                        style={{
                                            color: "black",
                                            fontSize: "18px",
                                            fontWeight: 500,
                                        }}
                                    >
                                        {t("page.waiting_rank")}
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                {/* {myData && myData.ranking > 0 && ( */}
                {getMyData && (
                    <div className="btn-page">
                        <StyledUsedBtn className="btn-redeem" themeColor={themes?.themeColor!}>
                            <div className="ranking-state-leaderboard">
                                <div className="ranking">
                                    <div className={"relative"}>
                                        {getMyData.ranking + 1 <= campaign?.numberOfRanking && (
                                            <img
                                                src={
                                                    campaign?.ranking[getMyData.ranking]?.badgeIcon
                                                }
                                            />
                                        )}
                                        <p
                                            style={{
                                                color:
                                                    getMyData.ranking + 1 <=
                                                    campaign?.numberOfRanking
                                                        ? "white"
                                                        : "black",
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                fontWeight: 700,
                                            }}
                                        >
                                            {getMyData.ranking + 1}
                                        </p>

                                        <span>
                                            {getMyData.ranking >= 0 &&
                                            getMyData.ranking + 1 <= campaign?.numberOfRanking ? (
                                                <RankIcon
                                                    color={
                                                        campaign?.ranking[getMyData.ranking]?.color
                                                    }
                                                />
                                            ) : (
                                                ""
                                            )}
                                        </span>
                                    </div>
                                </div>
                                <div className="img">
                                    <img
                                        src={
                                            myData?.imageUrl
                                                ? myData?.imageUrl
                                                : "../../images/img-profile-default-01.png"
                                        }
                                        alt=""
                                    />
                                </div>
                                <div className="name">{myData.firstName}</div>
                                <div className="tel">{myData.phoneNumber}</div>
                                <div className="point">{myData.totalPoint}</div>
                            </div>
                        </StyledUsedBtn>
                    </div>
                )}
            </StlyedSocialMedia>
        </>
    );
};

const StyledLoadingRankCard = styled(Card)`
    height: 62.5px;
    margin-bottom: 8px;
    padding: 0 16px;
    .ant-card-body {
        padding: 8px;
    }
`;

const StlyedSocialMedia = styled.div<{ themeColor: string }>`
    width: 100%;
    margin: 0 auto;
    height: 100vh;
    background-color: #f4f6fa;
    background-position: right top;
    background-repeat: no-repeat;
    position: relative;
    .btn-page {
        margin: 16px 0px;
        position: fixed;
        bottom: 16px;
        width: calc(100% - 32px);
        left: 50%;
        transform: translateX(-50%);
        max-width: 480px;
        /* background-color: #fff; */
        border-radius: 12px;
        box-shadow: rgba(14, 63, 120, 0.2) 0px 4px 20px 0px;
        button {
            width: 100%;
            padding: 0;
            margin: 0;
            border: none;
        }
    }
    .layout-content {
        position: absolute;
        margin-top: -50px;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        background-color: rgb(244, 246, 250);
        padding: 30px 16px 50px;
        overflow: hidden;
        bottom: 0px;
        width: 100%;
        height: 68%;
        .main-content {
            .tab-section {
                display: flex;
                justify-content: flex-start;
                grid-gap: 30px;
                color: ${(p) => p.themeColor};
                color: #9daaae;
                font-size: 16px;
                font-weight: 500;
                cursor: pointer;
                padding-bottom: 8px;
                .menu-active {
                    // border-bottom: 2px solid ${(p) => p.themeColor};
                    // color: ${(p) => p.themeColor};
                    color: #000;
                    font-weight: 600;
                    position: relative;
                    &:after {
                        content: "";
                        position: absolute;
                        width: 20px;
                        height: 3px;
                        bottom: -8px;
                        left: 50%;
                        transform: translateX(-50%);
                        border-radius: 4px;
                        // background-color: ${(p) => p.themeColor};
                        background: linear-gradient(
                            342deg,
                            rgba(162, 26, 115, 1) 0%,
                            rgba(227, 62, 59, 1) 100%
                        );
                    }
                }
            }
            .box-content {
                margin-top: 16px;
                height: 60vh;
                overflow: scroll;
                display: block;
                padding-bottom: 70px;
                .wrapper-state-leaderboard {
                    .ranking-state-leaderboard {
                        position: relative;
                        padding: 12px 16px 8px 125px;
                        background-color: #fff;
                        border-radius: 12px;
                        margin-bottom: 6px;
                        .ranking {
                            position: absolute;
                            left: 16px;
                            top: 12px;
                            img {
                                max-width: 35px;
                                max-height: 35px;
                            }
                            .relative {
                                position: relative;
                                background-color: transparent;
                                font-size: 14px;
                                font-weight: 600;
                                color: #000;
                                display: flex;
                                width: 35px;
                                height: 35px;
                                border-radius: 100%;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                span {
                                    position: absolute;
                                    right: -14px;
                                    top: -12px;
                                    img {
                                        width: 20px;
                                    }
                                }
                            }
                            .gold {
                                background-color: #ffb743;
                                color: #fff;
                            }
                            .silver {
                                background-color: #d4d2d2;
                                color: #fff;
                            }
                            .copper {
                                background-color: #ff8b55;
                                color: #fff;
                            }
                            .blue {
                                background-color: #76c0d9;
                                color: #fff;
                            }
                        }
                        .img {
                            position: absolute;
                            left: 71px;
                            top: 12px;
                            width: 35px;
                            hegiht: 35px;
                            img {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                                border-radius: 100%;
                            }
                        }
                        .name {
                            font-size: 14px;
                            font-weight: 600;
                            color: #000;
                            margin-bottom: 5px;
                        }
                        .tel {
                            font-size: 11px;
                            color: #9b9b9b;
                        }
                        .point {
                            position: absolute;
                            width: 100px;
                            display: inline-block;
                            top: 50%;
                            right: 16px;
                            transform: translateY(-50%);
                            text-align: center;
                            color: #76c0d9;
                            font-size: 16px;
                            font-weight: 600;
                        }
                    }
                }
            }
        }
    }
    .img-banner {
        width: 100%;
        position: relative;
        padding-top: 75%;
        z-index: 0;
        span {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
    .title-page {
        position: absolute;
        left: 50%;
        top: 15px;
        font-size: 16px;
        font-weight: 600;
        color: ${(p) => p.themeColor};
        z-index: 2;
        transform: translateX(-50%);
        display: inline-block;
        text-align: center;
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        top: 15px;
        display: flex;
        align-items: center;
        z-index: 1;
        span {
            margin-left: 10px;
            color: ${(p) => p.themeColor};
        }
    }
    .logo-survey {
        font-size: 32px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
`;

const StyledUsedBtn = styled.button<{ themeColor: string }>`
    .ranking-state-leaderboard {
        position: relative;
        padding: 12px 16px 8px 125px;
        background-color: #fff;
        border-radius: 12px;
        /* margin-bottom: 6px; */
        text-align: left;
        /* box-shadow: 0px 4px 20px 0px rgba(14, 63, 120, 0.2); */
        .ranking {
            position: absolute;
            left: 16px;
            top: 12px;
            img {
                max-width: 35px;
                max-height: 35px;
            }
            .relative {
                position: relative;
                background-color: transparent;
                font-size: 14px;
                font-weight: 600;
                color: #000;
                display: flex;
                width: 35px;
                height: 35px;
                border-radius: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                span {
                    position: absolute;
                    right: -14px;
                    top: -12px;
                    img {
                        width: 20px;
                    }
                }
            }
            .gold {
                background-color: #ffb743;
                color: #fff;
            }
            .silver {
                background-color: #d4d2d2;
                color: #fff;
            }
            .copper {
                background-color: #ff8b55;
                color: #fff;
            }
            .blue {
                background-color: #76c0d9;
                color: #fff;
            }
        }
        .img {
            position: absolute;
            left: 71px;
            top: 12px;
            width: 35px;
            hegiht: 35px;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 100%;
            }
        }
        .name {
            font-size: 14px;
            font-weight: 600;
            color: #000;
            margin-bottom: 5px;
        }
        .tel {
            font-size: 11px;
            color: #9b9b9b;
        }
        .point {
            position: absolute;
            width: 100px;
            display: inline-block;
            top: 50%;
            right: 16px;
            transform: translateY(-50%);
            text-align: center;
            color: #76c0d9;
            font-size: 16px;
            font-weight: 600;
        }
    }
`;
